// Área "common" — preenchida na cobertura de 4 idiomas. Ver src/i18n/index.jsx.
// Fallback: idioma ausente cai para pt e, se faltar, para a própria chave.
const common = {
  pt: {
    'common.close': 'Fechar',
    'common.loading': 'Carregando...',
    'common.page_not_found': 'Página não encontrada',
    'common.not_found_desc': 'Desculpe, a página que você está procurando não existe ou foi movida.',
    'common.back_home': 'Voltar para o Início',
    'common.go_login': 'Ir para Login',
    'common.contact_support': 'Contatar Suporte',
    'common.demo_notice': 'Este é um projeto de demonstração. Não é um banco real.',
    'common.all_rights': 'Todos os direitos reservados',
    'common.footer_desc': 'DogBank é um projeto de simulação bancária que oferece serviços financeiros fictícios.',
    'common.quick_links': 'Links Rápidos',
    'common.footer_home': 'Início',
    'common.about_us': 'Sobre nós',
    'common.contact': 'Contato',
    'common.demo_notice_full': 'Este é um projeto de demonstração. Não é um banco real e não realiza operações financeiras de verdade.',
  },
  es: {
    'common.close': 'Cerrar',
    'common.loading': 'Cargando...',
    'common.page_not_found': 'Página no encontrada',
    'common.not_found_desc': 'Lo sentimos, la página que buscas no existe o fue movida.',
    'common.back_home': 'Volver al inicio',
    'common.go_login': 'Ir al inicio de sesión',
    'common.contact_support': 'Contactar soporte',
    'common.demo_notice': 'Este es un proyecto de demostración. No es un banco real.',
    'common.all_rights': 'Todos los derechos reservados',
    'common.footer_desc': 'DogBank es un proyecto de simulación bancaria que ofrece servicios financieros ficticios.',
    'common.quick_links': 'Enlaces rápidos',
    'common.footer_home': 'Inicio',
    'common.about_us': 'Sobre nosotros',
    'common.contact': 'Contacto',
    'common.demo_notice_full': 'Este es un proyecto de demostración. No es un banco real y no realiza operaciones financieras reales.',
  },
  en: {
    'common.close': 'Close',
    'common.loading': 'Loading...',
    'common.page_not_found': 'Page not found',
    'common.not_found_desc': 'Sorry, the page you are looking for does not exist or has been moved.',
    'common.back_home': 'Back to home',
    'common.go_login': 'Go to login',
    'common.contact_support': 'Contact support',
    'common.demo_notice': 'This is a demo project. It is not a real bank.',
    'common.all_rights': 'All rights reserved',
    'common.footer_desc': 'DogBank is a banking simulation project that offers fictitious financial services.',
    'common.quick_links': 'Quick links',
    'common.footer_home': 'Home',
    'common.about_us': 'About us',
    'common.contact': 'Contact',
    'common.demo_notice_full': 'This is a demo project. It is not a real bank and does not perform real financial transactions.',
  },
  it: {
    'common.close': 'Chiudi',
    'common.loading': 'Caricamento...',
    'common.page_not_found': 'Pagina non trovata',
    'common.not_found_desc': 'Spiacenti, la pagina che stai cercando non esiste o è stata spostata.',
    'common.back_home': 'Torna alla home',
    'common.go_login': 'Vai al login',
    'common.contact_support': 'Contatta il supporto',
    'common.demo_notice': 'Questo è un progetto dimostrativo. Non è una banca reale.',
    'common.all_rights': 'Tutti i diritti riservati',
    'common.footer_desc': 'DogBank è un progetto di simulazione bancaria che offre servizi finanziari fittizi.',
    'common.quick_links': 'Link rapidi',
    'common.footer_home': 'Home',
    'common.about_us': 'Chi siamo',
    'common.contact': 'Contatto',
    'common.demo_notice_full': 'Questo è un progetto dimostrativo. Non è una banca reale e non effettua operazioni finanziarie reali.',
  },
};

export default common;
